import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Features from './components/Features/Features';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import WhatsAppButton from './components/WhatsApp/WhatsAppButton';
import PrivacyPolicy from './components/Privacy/PrivacyPolicy';
import TermsOfService from './components/Terms/TermsOfService';
import Onboard from './components/Onboard/Onboard';
import Dashboard from './components/Dashboard/Dashboard';
import DataDeletions from './components/DataDeletions/DataDeletions';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <Home />
              <Features />
              <About />
              <Contact />
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/onboard" element={<Onboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/data-deletions" element={<DataDeletions />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
